import { useCallback } from "react"
import { useAxiosInstances } from "../axios-instance"

export interface IEmailTestRequest {
    testEmail: string
    companyName: string
    contactEmail: string
    contactPhone: string
    primaryColor: string
    emailConfig: {
        authType: 'simple' | 'oauth2'
        host: string
        port: number
        user: string
        password?: string
        oauth2?: {
            provider?: 'google' | 'microsoft'
            clientId: string
            clientSecret: string
            tenant?: string
        }
    }
}

export interface IEmailTestResponse {
    message: string
    timestamp: string
    authType: 'simple' | 'oauth2'
    recipient: string
}

export const useEmailTestApi = () => {
    const { axiosAuthInstance } = useAxiosInstances()

    const sendTestEmailApi = useCallback((data: IEmailTestRequest): Promise<IEmailTestResponse> => {
        return axiosAuthInstance.post('/routes/send-test-email', data)
            .then(result => result.data.result)
    }, [axiosAuthInstance])

    return {
        sendTestEmailApi
    }
}
